<template>
  <li v-if="enabled" class="nav-item">
    <router-link
      to="/messages"
      class="nav-link chat-hb"
      :title="unread ? `${unread} unread message${unread === 1 ? '' : 's'}` : 'Messages'"
    >
      <i class="mdi mdi-24px mdi-message-text-outline"></i>
      <span v-if="unread > 0" class="chat-hb-count">{{ unread > 99 ? "99+" : unread }}</span>
    </router-link>
  </li>
</template>

<script>
import chat from "../store";
import { chatEnabledFor, storedUser } from "../config";

// Chat icon in the top header with the number of unread messages.
export default {
  name: "ChatHeaderBadge",
  computed: {
    enabled() {
      return chatEnabledFor(storedUser());
    },
    unread() {
      return chat.state.unread;
    },
  },
  created() {
    chat.start(); // fetches the count once; polling and new-message events keep it current
  },
};
</script>

<style scoped>
.chat-hb {
  position: relative;
  display: inline-flex;
  align-items: center;
}
.chat-hb-count {
  position: absolute;
  top: 6px;
  right: -2px;
  min-width: 19px;
  height: 19px;
  padding: 0 5px;
  border-radius: 10px;
  border: 2px solid #fff;
  background: #dc2626;
  color: #fff;
  font-size: 0.66rem;
  font-weight: 700;
  line-height: 15px;
  text-align: center;
}
</style>
